<template>
    <div>
        <div v-if="loading">
            <v-skeleton-loader type="list-item-avatar-two-line@3"/>
        </div>

        <div v-else>
            <v-list-item>
                <v-list-item-avatar>
                    <slot name="image">
                        <v-icon class="red--text">mdi-hand-coin</v-icon>
                    </slot>
                </v-list-item-avatar>

                <v-list-item-content class="red--text">
                    <v-list-item-title>{{total | number}}</v-list-item-title>

                    <v-list-item-subtitle>Балансы с организаторами</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-divider/>

            <v-list-item
                v-for="item in items"
                :key="item.owner.id"
                @click="toBalance(item)"
                exact
                two-line
            >
                <v-list-item-avatar>
                    <v-img :src="item.owner.preview"/>
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title>{{item.owner.title}}</v-list-item-title>
                    <v-list-item-subtitle>
                        <slot>
                            <BalancePreview
                                :data="item"
                                :loading="loading"
                            />
                        </slot>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </div>

        <v-row>
            <v-spacer/>
                <v-col cols="auto">
                    <v-btn
                        color="red"
                        text
                        type="button"
                        @click="$router.go(-1)"
                    >
                        Назад
                    </v-btn>
                </v-col>
        </v-row>

        <PageInfo
            title="Ваши балансы с организаторами"
            description="Балансы - ваши средства, учтённые организаторами в программе.</br>
            Программа не хранит деньги, а только позволяет организаторам вести их учёт."
        />
    </div>
</template>

<script>
import BalancePreview from '@/components/BalancePreview'
import PageInfo from '@/components/PageInfo'
import {appStates} from '@/constants'

export default {
    name: 'UserProfileBalances',
    components: {BalancePreview, PageInfo},
    created() {
        this.$client.get(this.$API.BALANCES.INFO)
        .then(this.initBalances)
        .catch(err => this.error = err)
        .finally(() => this.loading = false)
    },
    data() {
        return {
            items: [],
            loading: true,
            total: null
        }
    },
    methods: {
        initBalances(data) {
            this.total = data.total
            this.items = data.items
        },
        toBalance(balanceInfo) {
            this.$router.push({name: appStates.buyoutBalance.name, params: {balanceInfo}})
        }
    }
}
</script>

<style scoped>

</style>